export default{
     async registerCoach(context,payload){
         const userId = context.rootGetters.userId
         let coachData = {
             firstName: payload.firstName,
             lastName: payload.lastName,
             hourlyRate: payload.rate,
             areas: payload.areas,
             description: payload.description,
             id: userId
         }
         const token = context.rootGetters.token
         const response = await fetch(`https://coach-finder-vue-dd363-default-rtdb.firebaseio.com/coaches/${userId}.json?auth=${token}`,{
             body: JSON.stringify(coachData),
             method:'PUT'
         })
         let responseData = await response.json()
         if(!response.ok){  
             const error = new Error(responseData.message || 'Failed to fetch')
             throw error
         }

         context.commit('addNewCoach',{
             ...coachData,
             userId: userId
         })
     },
     async loadCoaches(context,payload){
         if(!context.getters.shouldFetch && !payload.forceRefresh){
             return
         }  
         const response = await fetch(`https://coach-finder-vue-dd363-default-rtdb.firebaseio.com/coaches.json`);
         const responseData = await response.json()
         if(!response.ok){
             const error = new Error(responseData.message || 'Failed to fetch')
             throw error
         }
      
         const coaches = [];
         for(let key in responseData){
             let{firstName,lastName,description,areas,hourlyRate,id} = responseData[key]
             let coachesData = {
                 firstName,
                 lastName,description,areas,hourlyRate,id
                 
             }
             coaches.push(coachesData)
         }
         context.commit('setCoaches',coaches)
         context.commit('setFetchTime')
     }
}